import { render, staticRenderFns } from "./AssessmentQuestion.vue?vue&type=template&id=5c28c506"
import script from "./AssessmentQuestion.vue?vue&type=script&lang=js"
export * from "./AssessmentQuestion.vue?vue&type=script&lang=js"
import style0 from "./AssessmentQuestion.vue?vue&type=style&index=0&id=5c28c506&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports